import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";
import { API } from "../../constants/API";

interface amazonLWSalesDataInterface {
    MTD_UNITS_SALES:any | number;
}

interface amazonYtdSalesDataInterface {
    YTD_UNITS_SALES:any
}

interface amazonLtdSalesDataInterface {
    LTD_UNITS_SALES:any | number
}

interface amazonDataObj {
mtdData:amazonLWSalesDataInterface,
  ytdData:amazonYtdSalesDataInterface, 
  ltdData:amazonLtdSalesDataInterface;
  dataAsOf?: string | null;
}

interface TitleListAmazonState {
  data: amazonDataObj;
  status: string;
  statusCode: number;
  error: string | null;
  isLoading: boolean;
}
const initialState: TitleListAmazonState = {
  data: {
    mtdData:{
    //   DATE:"",
    //   LAST_WEEK_SALES:0
    MTD_UNITS_SALES:0
    },
    ytdData:{
    //   DATE:"",
    //   YTD_SALES:0
    YTD_UNITS_SALES:0
    },
    ltdData:{
    //   LTD_SALES:0
    LTD_UNITS_SALES:0
    },
    dataAsOf: null,
  },
  status: "",
  error: null,
  statusCode: 0,
  isLoading: false,
};
var BASE_URL= process.env.REACT_APP_BASE_URL
export const FetchTitleListAmazonRecord = createAsyncThunk(
  "FetchTitleListAmazonRecord",
  async (data: any, { rejectWithValue }) => {
    try {
    console.log(API.AmazonTITLESALESDATA,'amazon')
      const response = await axios.post(`${BASE_URL}/title_sales/fetchTitleAmazonGrossSales`,data);
      return response;
    } catch (err: any) {
      return rejectWithValue(err.response);
    }
  }
);

const TitleListAmazonSlice = createSlice({
  name: "TitleListAmazonData",
  initialState,
  reducers: {
    emptyBookscanPosSales:(state) => {
      state.data = initialState.data;
      state.error = initialState.error;
      state.isLoading = initialState.isLoading;
      state.status = initialState.status;
      state.statusCode = initialState.statusCode;
    }
  },
  extraReducers(builder) {
    builder
      .addCase(FetchTitleListAmazonRecord.pending, (state) => {
        state.isLoading = true;
        state.status = "Loading";
      })
      .addCase(FetchTitleListAmazonRecord.fulfilled, (state, action) => {
        state.isLoading = false;
        state.status = "success";
        state.data = action.payload.data
        console.log(action.payload.data,'amazondata')
      })
      .addCase(FetchTitleListAmazonRecord.rejected, (state) => {
        state.isLoading = false;
        state.status = "Failed";
        state.error = "Error";
      });
  },
});

export const {
  emptyBookscanPosSales
} = TitleListAmazonSlice.actions;
export default TitleListAmazonSlice.reducer;
